const dev = {
    apiGateway: {
        URL: "http://localhost:8094/system"
    },
    apiV4: {
        admin: {
            URL: "http://localhost:8094/api/v2"
        },
        user: {
            URL: "http://localhost:8094/api/v2"
        }
    },
    sanctum: {
        admin: {
            URL: "http://localhost:8094"
        },
        user: {
            URL: "http://localhost:8094"
        }
    },
    wsUrl: "http://localhost:8765",
    features: {
        voiceWholesale: true,
        smsWholesale: false
    },
    usageReport: {
        basePath: "http://localhost:8094/external/"
    },
    ports: {
        admin: 3000,
        user: 3001
    }
};

const prod = {
    apiGateway: {
        URL: "/system"
    },
    apiV4: {
        admin: {
            URL: "/api/v2"
        },
        user: {
            URL: "/api/v2"
        }
    },
    sanctum: {
        admin: {
            URL: ""
        },
        user: {
            URL: ""
        }
    },
    wsUrl: "http://localhost:8765",
    features: {
        voiceWholesale: true,
        smsWholesale: false
    },
    usageReport: {
        basePath: "/external/"
    },
    ports: {
        admin: 8081,
        user: 8082
    }
};

// Determine which config to use
let config;
if (process.env.REACT_APP_STAGE === 'prod') {
    config = prod;
} else if (process.env.NODE_ENV === 'production') {
    config = prod;
} else {
    config = dev;
}

export default {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 5000000,
    ...config
};
